export default __webpack_public_path__ + "static/media/gold-medal.9f44ce2f.svg";